import { CustomMapComponent, CustomTextField, LoaderComponent } from "@/shared/components/ui";
import { Grid, IconButton, InputAdornment, SvgIcon, Tooltip } from "@mui/material";
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import GlobeEuropeAfricaIcon from '@heroicons/react/24/solid/GlobeEuropeAfricaIcon';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useCallback, useEffect, useState } from "react";
import { gridSize, obtenerUbicacion } from "@/shared";
import { CoordenadasType } from "@/shared/components/ui/Maps/CustomMapComponent";
import { postPoligono } from "@/shared/actions/erp";
import { useUiStore } from "@/store/ui";
import { AlertSeverityEnum, NacionalidadEnum } from "@/shared/interfaces";

interface FormCoordendasProps {
  form: any
  name: string
  label: string
  defaultValue?: string | number | undefined
  handleDataUbicacion?: (coord: string) => void
  size?: any;
  enableLocationOnChange?: boolean;
  onlyValueLocation?: boolean;
  disabled?: boolean
  canDragMarker?: boolean,
  canLocationSearch?: boolean
required?: boolean
}
export default function CustomCoordendasForm({
  name,
  form,
  label,
  defaultValue,
  size = gridSize,
  enableLocationOnChange = false,
  onlyValueLocation = false,
  disabled = false,
  handleDataUbicacion,
  canDragMarker = true,
  canLocationSearch = true,
  required = true
}: FormCoordendasProps) {

  const [modal, setModal] = useState(false);
  // const [errorZone, setErrorZone] = useState<boolean>(false);
  const [timesInChange, setTimesInChange] = useState<number>(0);
  const [loadingCurrentPosition, setLoadingCurrentPosition] = useState<boolean>(false);

  const [latLng, setLatLng] = useState<CoordenadasType>({
    lat: 0,
    lng: 0
  });

  const {
    formState: { errors },
  } = form;


  const setAlert = useUiStore((s) => s.setAlert);

  const handleApiUbicacioActual = useCallback(
    async () => {
      setLoadingCurrentPosition(true)
      try {
        const coordenadasApi = await obtenerUbicacion()
        const { latitude, longitude } = coordenadasApi
        setLatLng({ lat: latitude, lng: longitude })
        form.setValue(name, `${latitude},${longitude}`);
        form.setValue("latitud", latitude.toString());
        form.setValue("longitud", longitude.toString());

        /* form.reset({
          ...form.getValues(),
          [name || "coordenadas"]: `${latitude},${longitude}`,
          latitud: latitude.toString(),
          longitud: longitude.toString(),
        }); */

        handleDataUbicacion && handleDataUbicacion(`${latitude},${longitude}`)

        if (!onlyValueLocation) {
          handleVerificarCoordenada(latitude.toString(), longitude.toString());
        }
      } catch (_error) {
        console.log(_error, 'error');
      } finally {
        setLoadingCurrentPosition(false)
      }
    },
    [],
  )


  ///* buscar si exsiste localidad con la cordenada obtenida

  const handleVerificarCoordenada = useCallback(
    async (lat: string, lng: string) => {
      try {
        form.reset({
          ...form.getValues(),
          lat: form.getValues().lat,
          lng: form.getValues().lng,
        })
        const resp = await postPoligono({
          latitud: lat,
          longitud: lng,
        });

        form.reset({
          ...form.getValues(),
          pais: NacionalidadEnum.CODIGO,
          zona: resp.data.codigo,
          provincia: resp.data.provincia_data?.codigo,
          ciudad: resp.data.ciudad_data?.codigo,
          zona_nombre: resp.data.nombre,
          provincia_nombre: resp.data.provincia_data?.nombre,
          ciudad_nombre: resp.data.ciudad_data?.nombre,
          sector_tentativo: null,
          tiene_cobertura: true,
        });

        // setErrorZone(false);
      } catch (error) {
        // setErrorZone(true);
        // if (errorZone) {
          setAlert(
            true,
            "Lo sentimos, no existe cobertura para las coordenas asignadas",
            AlertSeverityEnum.error,
            5000
          );
        // }
        form.reset({
          ...form.getValues(),
          sector_tentativo: null,
          zona: "",
          ciudad: "",
          provincia: "",
          zona_nombre: "",
          provincia_nombre: "",
          ciudad_nombre: "",

          tiene_cobertura: false,
        });
      }
    },
    [],
  )

  useEffect(() => {
    if (defaultValue) {
      setLatLng({
        lat: +defaultValue?.toString().split(',')[0],
        lng: +defaultValue?.toString().split(',')[1]
      })
    }
    setTimesInChange(timesInChange + 1)
  }, [defaultValue]);

  // ===========================================================================
  // Se utiliza el contador para evitar reloading al cargar el componente mientras se cambia de tabs
  // ===========================================================================
  useEffect(() => {
    setTimesInChange(timesInChange + 1)
    if (enableLocationOnChange && timesInChange > 1)
      handleVerificarCoordenada((latLng.lat).toString(), (latLng.lng).toString())
  }, [latLng.lat, latLng.lng]);

  return (
    <>
      <Grid container item  {...size} justifyContent={'space-between'} >

        <CustomTextField
          disabled={disabled}
          required={required}
          type="coordenada"
          control={form.control}
          name={name}
          defaultValue={defaultValue}
          size={{
            xs: 10,
            sm: 10,
            md: 10,
            lg: 10
          }}
          label={label}
          error={errors[name]}
          startAdornment={
            <InputAdornment position="start">
              <SvgIcon fontSize="small">
                <GlobeEuropeAfricaIcon />
              </SvgIcon>
            </InputAdornment>
          }
          helperText={''} //
          onChangeValue={async (value: string, valid?: boolean) => {
            if (valid) {
              handleDataUbicacion && handleDataUbicacion(value)
              let coord = value.split(',');
              setLatLng({ lat: +coord[0], lng: +coord[1] });
            }

          }}
        />

        <Grid item alignItems={'end'}>
          <Tooltip title='Abrir Mapa' placement="top" >
            <IconButton onClick={() => {
              setModal(true)
            }} sx={{ width: "15px" }} >
              <FmdGoodIcon color="info" />
            </IconButton>
          </Tooltip>
        </Grid>

        {canLocationSearch &&
          <Grid item alignItems={'end'}>
            {
              (!loadingCurrentPosition) ?
                <Tooltip title='Obtener ubicación actual' placement="top" >
                  <IconButton onClick={() => {
                    handleApiUbicacioActual()
                  }} sx={{ width: "15px" }} disabled={disabled}>
                    <LocationSearchingIcon color="info" />
                  </IconButton>
                </Tooltip>
                :
                <LoaderComponent />
            }
          </Grid>
        }

      </Grid>

      {modal && (
        <ScrollableDialogProps
          open={modal}
          title={`Seleccionar coordenada`}
          onCloseIcon={() => setModal(false)}
          //minWidth="60%"

          contentNode={
            <>
              <CustomMapComponent
                coordenadas={{
                  lat: latLng.lat,
                  lng: latLng.lng
                }}
                canDragMarker={canDragMarker}

                setLatLng={(coordenadas) => {
                  // console.log(coordenadas, 'coord map');
                  handleDataUbicacion && handleDataUbicacion(`${coordenadas.lat},${coordenadas.lng}`)
                  setLatLng(coordenadas)
                  form.setValue(name, `${coordenadas.lat},${coordenadas.lng}`)
                }}
              />
            </>
          }
        />
      )}
    </>
  )

}